import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminTransactions from './subscriptions/AdminTransactions';

const AdminTransactionsPage = () => (
  <AdminLayout>
    <AdminTransactions />
  </AdminLayout>
);

export default AdminTransactionsPage;
